export default class UnitUtil {
  static seconds(value: number): number {
    return Math.floor((value / 1000) % 60);
  }

  static minutes(value: number): number {
    return Math.floor((value / (60 * 1000)) % 60);
  }

  static hours(value: number): number {
    return Math.floor((value / (60 * 60 * 1000)) % 24);
  }

  static days(value: number): number {
    return Math.floor((value / (24 * 60 * 60 * 1000)) % 60);
  }

  static weeks(value: number): number {
    return Math.floor((value / (7 * 24 * 60 * 60 * 1000)) % 60);
  }

  static years(value: number): number {
    return Math.floor(value / 31536000000);
  }
}
